// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Constants.tst template. 
// !!Do not modify this file or change may be lost!!
/* eslint-disable */
export default class GroupOptionType {
    public static readonly MAIN: number = 1;
    public static readonly ALTERNATE: number = 2;
    public static readonly OPTIONAL: number = 3;
}
